// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wjv3","col":"styles_col__1XL9x"};